export default __webpack_public_path__ + "images/a1b10b135645d3c29d8a8dc1db43ac5f.png";